// Pure helpers for the dynamically discovered work-repo docs
// (see hooks/use-work-docs.ts). Titles come from filenames; the override map
// is only for names the kebab-case heuristic can't produce.
const TITLE_OVERRIDES: Record<string, string> = {
  'README.md': 'README',
  'app.md': 'App spec',
}

export function slugFromFile(path: string): string {
  // Namespace guides so guides/setup.md and a root setup.md don't collide.
  const clean = path.replace(/\.md$/, '').toLowerCase()
  return clean.replace(/\//g, '-')
}

export function docTitleFromFile(name: string): string {
  const base = name.split('/').pop() ?? name
  const override = TITLE_OVERRIDES[base]
  if (override) return override
  const words = base.replace(/\.md$/, '').split('-').join(' ')
  return words[0]!.toUpperCase() + words.slice(1)
}
